// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"JTdL2","tooltiptext":"g62JE"};